import React from "react";
import { Link } from "react-router-dom";
import Image from "../Image";

const ProjectImageDetailPage = ({dataId, image,}) => {
  return (
    <div className="brick">
    <Link to={image} className="js-img-viwer" data-id={dataId}>
    <Image className="img-fluid img-100 center-block" image={image} />
    </Link>
    </div>
  );
};

export default ProjectImageDetailPage;
